import { createAction, props } from '@ngrx/store';
import Stripe from 'stripe';
import {
  IAccountDTO,
  IAddress,
  IAccountProfile,
  IAccountAddress,
  IPaymentMethod
} from '@care-portals/api-interfaces';

/* -------------------------------------------------------------------------- */
/*                              INIT LOAD ACCOUNT                             */
/* -------------------------------------------------------------------------- */

export const loadAccount = createAction('[Account] Load Account');
export const loadAccountSuccess = createAction(
  '[Account] Load Account Success',
  props<{ accountData: IAccountDTO }>()
);
export const loadAccountFailure = createAction(
  '[Account] Load Account Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                   profile                                  */
/* -------------------------------------------------------------------------- */

export const enableEditProfile = createAction('[Account] Enable Edit Profile');
export const cancelEditProfile = createAction('[Account] Cancel Edit Profile');
export const editProfile = createAction(
  '[Account] Edit Profile',
  props<{ req: IAccountProfile }>()
);
export const editProfileSuccess = createAction(
  '[Account] Edit Profile Success',
  props<{ req: IAccountProfile }>()
);
export const editProfileFailure = createAction(
  '[Account] Edit Profile Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                               PAYMENT METHOD                               */
/* -------------------------------------------------------------------------- */

/* --------------------------- Load PAYMENT METHOD -------------------------- */

export const loadPaymentMethods = createAction('[Account] Load Payment Method');

export const loadPaymentMethodsSuccess = createAction(
  '[Account] Load Payment Method Success',
  props<{ paymentMethodsList: IPaymentMethod[] }>()
);

export const loadPaymentMethodsFailure = createAction(
  '[Account] Load Payment Method Failure',
  props<{ error: Error }>()
);

/* --------------------------- Add Payment Method --------------------------- */

export const showAddPaymentMethod = createAction(
  '[Account] Show Add Payment Method'
);

export const addPaymentMethodAndAddress = createAction(
  '[Account] Add Payment Method And IAddress',
  props<{ paymentMethodId: string; address: IAddress }>()
);

export const addPaymentMethod = createAction(
  '[Account] Add Payment Method',
  props<{ token: string; zip?: string }>()
);

export const addPaymentMethodSuccess = createAction(
  '[Account] Add Payment Method Success'
);

export const addPaymentMethodFailure = createAction(
  '[Account] Add Payment Method Failure',
  props<{ error: Error }>()
);

/* ----------------------------- Remove Payment Method ---------------------------- */

export const removePaymentMethod = createAction(
  '[Account] Remove Payment Method',
  props<{ paymentMethodId: string }>()
);

export const removePaymentMethodSuccess = createAction(
  '[Account] Remove Payment Method Success'
);

export const removePaymentMethodFailure = createAction(
  '[Account] Remove Payment Method Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                  Password                                  */
/* -------------------------------------------------------------------------- */

/* ----------------------------- change password ---------------------------- */
export const changePassword = createAction(
  '[Account] Change Password',
  props<{ currentPassword: string; newPassword: string }>()
);
export const changePasswordSuccess = createAction(
  '[Account] Change Password Success'
);
export const changePasswordFailure = createAction(
  '[Account] Change Password Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                Consultations                               */
/* -------------------------------------------------------------------------- */

export const getCustomerConsultations = createAction(
  '[Account] Get Customer Consultations'
);
export const getCustomerConsultationsSuccess = createAction(
  '[Account] Get Customer Consultations Success'
);
export const getCustomerConsultationsFailure = createAction(
  '[Account] Get Customer Consultations Failure',
  props<{ error: Error }>()
);

/* -------------------------------------------------------------------------- */
/*                                   Addresses                                  */
/* -------------------------------------------------------------------------- */

export const enableEditAddress = createAction('[Account] Enable Edit Address');
export const cancelEditAddress = createAction('[Account] Cancel Edit Address');
export const editAddress = createAction(
  '[Account] Edit Address',
  props<{ req: IAccountAddress }>()
);
export const editAddressSuccess = createAction(
  '[Account] Edit Address Success',
  props<{ req: IAccountAddress }>()
);
export const editAddressFailure = createAction(
  '[Account] Edit Address Failure',
  props<{ error: Error }>()
);
